import type { EvidenceItem, TextModeObservation } from '../types/text-mode.types';

export function canRemoveEvidenceItem(
  item: EvidenceItem,
  originalObservation?: Pick<TextModeObservation, 'source'> | null,
): boolean {
  return (originalObservation?.source ?? item.source) === 'note';
}
